var React = require('react');

function SelectionRadioDefault (props) {
    return React.createElement("svg",props,React.createElement("circle",{"cx":"8","cy":"8","r":"7.5","fill":"#FFF","fillRule":"evenodd","stroke":"#E5E7E8"}));
}

SelectionRadioDefault.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = SelectionRadioDefault;

SelectionRadioDefault.default = SelectionRadioDefault;
